import { render, staticRenderFns } from "./setPromptSecretQustionPage.vue?vue&type=template&id=4fe46f76&scoped=true&"
import script from "./setPromptSecretQustionPage.vue?vue&type=script&lang=js&"
export * from "./setPromptSecretQustionPage.vue?vue&type=script&lang=js&"
import style0 from "./setPromptSecretQustionPage.vue?vue&type=style&index=0&id=4fe46f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe46f76",
  null
  
)

export default component.exports